import { Typography } from "@suraasa/placebo-ui"
import { Assignment, LearningOutcome } from "api/resources/assignments/types"

type Props = {
  acs: Assignment["assignmentAssessmentCriteria"]
  learningOutcomesContent?: LearningOutcome[]
  pedagogicalSkillEvaluated?: string | null
}

const LearningOutcomesContent = ({
  acs,
  learningOutcomesContent,
  pedagogicalSkillEvaluated,
}: Props) => {
  const updatedACs = learningOutcomesContent?.flatMap(
    lo => lo.assessmentCriterion
  )

  return (
    <>
      {acs.map((data, index) => {
        const acName = updatedACs?.find(ac => ac.number === data.number)?.name

        const loName = learningOutcomesContent?.find(
          lo => lo.number === data.learningOutcome.number
        )?.name

        return (
          <div
            key={index}
            style={{ boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.05)" }}
            className="mb-2 rounded-[12px] border border-surface-200 bg-common-white-500 p-2"
          >
            <div className="mb-1 flex items-start">
              <Typography variant="strong" className="me-1 shrink-0">
                AC
              </Typography>
              <Typography>{acName || data.name}</Typography>
            </div>
            <div className="flex items-start">
              <Typography variant="strong" className="me-1 shrink-0">
                LO
              </Typography>
              <Typography>{loName || data.learningOutcome.name}</Typography>
            </div>
          </div>
        )
      })}

      {pedagogicalSkillEvaluated && (
        <div className="flex flex-col items-start rounded-xl border border-success-200 bg-success-100 p-1.5">
          <Typography className="mb-0.5 text-success-900" variant="title4">
            Pedagogical Skill Evaluated
          </Typography>
          <Typography variant="smallBody" className="text-success-900">
            {pedagogicalSkillEvaluated}
          </Typography>
        </div>
      )}
    </>
  )
}

export default LearningOutcomesContent
